<div class="bathdai-change-confirm">
    <div class="bathdai-change-confirm__header">
        <h2 class="bathdai-change-confirm__title">{{ daiName }}</h2>
        <div class="bathdai-change-confirm__actions">
            <button (click)="cancel()" class="btn cancel">{{ BUTTON.CANCEL }}</button>
            <button (click)="confirm()" class="btn save">{{ BUTTON.CONFIRM }}</button>
        </div>
    </div>
    <div class="bathdai-change-confirm__intro">
        <p class="bathdai-change-confirm__lead">{{ TEXT.LEAD }}</p>
    </div>

    <h3 class="bathdai-change-confirm__section">{{ TEXT.SECTION_IMPACT }}</h3>

    <ng-container *ngIf="roomChange">
        <ng-container *ngTemplateOutlet="block; context: { label: TEXT.ROOM_CHANGE, change: roomChange }"></ng-container>
    </ng-container>
    <ng-container *ngIf="patternChange">
        <ng-container *ngTemplateOutlet="block; context: { label: TEXT.PATTERN_CHANGE, change: patternChange }"></ng-container>
    </ng-container>
    <!-- Days the move would create in the target room, last in the dialog: each one ticked by default
         (the すべて選択 box ticks/unticks all); unticked ones are sent back as skipped. -->
    <div class="bathdai-change-confirm__block" *ngIf="created">
        <h3 class="bathdai-change-confirm__section">{{ TEXT.CREATED_TITLE }}</h3>
        <div class="bathdai-change-confirm__created-intro">
            <p>{{ TEXT.CREATED_LEAD }}</p>
            <p class="bathdai-change-confirm__created-caution">{{ TEXT.CREATED_NOTE }}</p>
        </div>
        <div class="bathdai-change-confirm__created-all">
            <caremoni-checkbox [value]="allCreatedChecked" (onClick)="toggleAllCreated($event)"></caremoni-checkbox>
            <span class="bathdai-change-confirm__created-label" (click)="toggleAllCreated(!allCreatedChecked)">{{ TEXT.CREATED_CHECK_ALL }}</span>
        </div>
        <ul class="bathdai-change-confirm__created">
            <li class="bathdai-change-confirm__created-item" *ngFor="let option of created.dates">
                <caremoni-checkbox [value]="option.checked" (onClick)="toggleCreated(option, $event)"></caremoni-checkbox>
                <span class="bathdai-change-confirm__created-label" (click)="toggleCreated(option, !option.checked)">{{ option.label }}</span>
            </li>
        </ul>
    </div>
</div>

<!-- One block: the from → to line, the two column titles, then both date lists in a single scroll area. -->
<ng-template #block let-label="label" let-change="change">
    <div class="bathdai-change-confirm__block">
        <div class="bathdai-change-confirm__block-title">
            <span class="bathdai-change-confirm__block-label">{{ label }}</span>
            <span class="bathdai-change-confirm__block-diff">{{ change.from || TEXT.NONE }}<span class="bathdai-change-confirm__arrow">→</span>{{ change.to || TEXT.NONE }}</span>
        </div>
        <div class="bathdai-change-confirm__columns">
            <div class="bathdai-change-confirm__list-title">{{ change.removed.title }}</div>
            <div class="bathdai-change-confirm__list-title">{{ change.added.title }}</div>
        </div>
        <div class="bathdai-change-confirm__columns bathdai-change-confirm__lists">
            <ul class="bathdai-change-confirm__list bathdai-change-confirm__list--removed">
                <li *ngFor="let date of change.removed.dates">{{ date }}</li>
                <li class="bathdai-change-confirm__none" *ngIf="change.removed.dates.length === 0">{{ TEXT.NONE }}</li>
            </ul>
            <ul class="bathdai-change-confirm__list bathdai-change-confirm__list--added">
                <li *ngFor="let date of change.added.dates">{{ date }}</li>
                <li class="bathdai-change-confirm__none" *ngIf="change.added.dates.length === 0">{{ TEXT.NONE }}</li>
            </ul>
        </div>
    </div>
</ng-template>
